import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { Input } from 'reactstrap';
import Select from 'react-select';
import NavItem from './NavItem';
import './styles/filter.scss';
import imgfSearch from '../../assets/img/search.svg';
import imgfSearchFocus from './img/icon-search.svg';
import imgfSelectDown from './img/select-down.svg';
import imgfSelectUp from './img/select-up.svg';
import imgCloseBlueIcon from '../../assets/img/closeBlueIcon.svg';
import RcmpModalVideosTutorials from '../../components/ModalVideoPlayer';

class Filter extends Component {
  constructor(oProps) {
    super(oProps);

    this.state = {
      bSearching: false,
      cText: '',
      cOrderBy: '',
      cOrderType: 'asc',
      isFocused: false,

      flex: this.props.flex
    };

    this.searchRef = React.createRef();

    this.debounceTimer = null;
  }

  customDebounce = (callback, delay) => {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(callback, delay);
  };

  componentDidMount() {
    const { cDefaultOrder } = this.props;

    if (cDefaultOrder != '') {
      this.setState({
        cOrderBy: cDefaultOrder
      });
    }
  }

  renderOrder = () => {
    const { aOrderItems, fnOnType, bIsOrderActive } = this.props;
    const { cOrderType, cOrderBy, cText } = this.state;
    let { cDefaultOrder } = this.props;

    if (!bIsOrderActive) {
      return '';
    }

    if (aOrderItems.length > 0) {
      if (!cDefaultOrder) {
        cDefaultOrder = aOrderItems[0].value;
      }

      return (
        <>
          <Select
            className="v2-select"
            classNamePrefix="react-select"
            options={aOrderItems}
            noOptionsMessage={() => intl.get('sem_opcoes')}
            components={{ DropdownIndicator: () => null }}
            value={aOrderItems.filter(oObj => oObj.value === cOrderBy)}
            defaultValue={cDefaultOrder}
            placeholder={intl.get('select')}
            onChange={evt => {
              const cNewOrderBy = evt.value;
              this.handleOrderChange(evt);
              fnOnType(evt, {
                cText,
                cOrderBy: cNewOrderBy,
                cOrderType
              });
            }}
          />
          <NavItem
            className="v2-filter-orderDirection"
            cIcon={cOrderType === 'asc' ? imgfSelectUp : imgfSelectDown}
            cText={intl.get('direction')}
            onClick={evt => {
              let cNewOrderType = 'asc';
              if (cOrderType === 'asc') {
                cNewOrderType = 'desc';
              }
              this.setState({
                cOrderType: cNewOrderType
              });
              fnOnType(evt, {
                cText,
                cOrderBy,
                cOrderType: cNewOrderType
              });
            }}
          />
        </>
      );
    }
    return '';
  };

  getFilterParams = () => {
    const { cText, cOrderBy, cOrderType } = this.state;

    return {
      cText,
      cOrderBy,
      cOrderType
    };
  };

  updateSearchText = (evt, cText) => {
    const { fnOnType } = this.props;
    const { cOrderBy, cOrderType } = this.state;

    if (evt) evt.persist();

    this.setState({ cText });
    this.customDebounce(() => {
      fnOnType(evt, {
        cText,
        cOrderBy,
        cOrderType,
      });
    }, 500);
  };

  handleOrderChange = evt => {
    this.setState({
      cOrderBy: evt.value
    });
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  closeSearch = () => {
    this.setState({ bSearching: false });
    this.updateSearchText(null, '');
  };

  openSearch = () => {
    this.setState(
      { bSearching: true },
      () => this.searchRef.current.focus(),
    );
  }

  getSearching = () => {
    const { fnOnType, cFilterName, cPlaceholder } = this.props;
    const { cOrderBy, cOrderType, cText, isFocused } = this.state;
    return (
      <div className="v2-filter-searching">
        <span className="v2-filter-searching-icon">
          <img
            src={isFocused ? imgfSearchFocus : imgfSearch}
            alt={intl.get('search')}
            className="v2-filter-searching-image"
            style={{ width: '21px', height: '21px' }}
          />
        </span>
        <span
          className="v2-filter-searching-nav close"
          role="button"
          tabIndex={0}
          onClick={this.closeSearch}
          onKeyUp={this.closeSearch}
        >
          <img
            src={imgCloseBlueIcon}
            alt={intl.get('close')}
            style={{ height: '17px' }}
          />
        </span>
        <Input
          className="v2-filter-searching-input"
          type="text"
          innerRef={this.searchRef}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onKeyUp={(evt) => {
            if (evt.key !== 'Escape') return;
            if (cText === '') {
              this.closeSearch();
            } else {
              this.updateSearchText(evt, '');
            }
          }}
          name={cFilterName}
          id={cFilterName}
          placeholder={cPlaceholder || 'Digite...'}
          value={cText}
          onChange={evt => this.updateSearchText(evt, evt.target.value)}
        />
      </div>
    );
  };

  getNotSearching = () => {
    return (
      <div
        className={this.state.flex ? `v2-filter-notsearching v2-filter-notsearching-flex` : 'v2-filter-notsearching'}
      >
        {this.renderButtons()}
        {this.renderCheckboxes()}
        {this.renderOrder()}
        <ul>
          {this.renderItems()}
          <NavItem
            className="v2-filter-iconSearch"
            cIcon={imgfSearch}
            cIconFocus={imgfSearch}
            cText={intl.get('search')}
            onClick={this.openSearch}
          />
          {this.renderRightMenu()}
        </ul>
      </div>
    );
  };

  renderRightMenu = () => {
    const { rcmpRightMenu } = this.props;
    return rcmpRightMenu ?? '';
  };

  renderButtons = () => {
    const { aButtons } = this.props;
    const rcmpButtons = Object.keys(aButtons).map(cKey => aButtons[cKey]);
    return rcmpButtons;
  };

  renderCheckboxes = () => {
    const { aCheckboxes } = this.props;
    if (typeof aCheckboxes === 'undefined') {
      return '';
    }

    const rcmpCheckboxes = Object.keys(aCheckboxes).map(cKey => aCheckboxes[cKey]);
    return rcmpCheckboxes;
  };

  renderItems = () => {
    const { aItems } = this.props;
    if (typeof aItems === 'undefined') {
      return '';
    }

    const rcmpNavItems = Object.keys(aItems).map(cKey => aItems[cKey]);
    return rcmpNavItems;
  };

  render = () => {
    const { bSearching } = this.state;
    const { className, bHasVideoTutorial= false, } = this.props;
    const isSpecificFolder = /\/folder_old\/\d+$/.test( window.location.pathname);

    let result = '';
    let cClassName = 'v2-cardheader-filter ';

    if (bSearching) {
      result = this.getSearching();
    } else {
      result = this.getNotSearching();
    }

    if (className.length > 0) {
      cClassName += className;
    }
    return (
    <div className={bHasVideoTutorial ? 'cardheader-container' : ""}>
      {bHasVideoTutorial && <div className={`cardheader-left-side ${isSpecificFolder ? 'specific-folder' : 'general-folder'}`}>
        <RcmpModalVideosTutorials />
      </div>}
      <div className={cClassName}>{result}</div>
    </div>);
  };
}
Filter.defaultProps = {
  fnOnType: null,
  cFilterName: '',
  cPlaceholder: '',
  aOrderItems: [],
  cDefaultOrder: '',
  aButtons: [],
  aCheckboxes: [],
  aItems: [],
  className: '',
  bIsOrderActive: true,
  rcmpRightMenu: ''
};
export default Filter;
